<template>
  <m-form :title="title" :showList="false" :show-list-btn="false" :canEdit="false" @clearForm="clearForm(true)">
    <template #header-btns></template>
    <template>
      <v-row>
        <v-col cols="12" md="8">
          <v-row>
            <v-col cols="12" md="3">
              <span>وضعیت: </span>
              <span v-if="item.is_paid" class="success--text"> پرداخت شده</span>
              <span v-else class="error--text">پرداخت نشده</span>
            </v-col>
            <v-col cols="12" md="3" v-if="item.expired_at">
              <span>تاریخ پایان اشتراک: </span>
              <span>{{  toJDate(item.expired_at) }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <m-datatable
              :headers="headers"
              :items="rows"
              :filters="{}"
              :show-applied-filters="false"
              :show-select="false"
              :show-export-btns="false"
          >
            <template #item.remove="{ item }">

              <v-btn v-if="item.id" @click="removeRow(item)" icon class="red--text">
                <v-img max-height="25" max-width="25" src="/img/icons/delete.svg"></v-img>
              </v-btn>
            </template>
          </m-datatable>
        </v-col>
      </v-row>

    </template>
    <template class="d-flex justify-center justify-md-end">
      <v-btn depressed left v-if="!item.is_paid" @click="paymentDialog = true"
             class="w-100px rounded-lg float-left ml-3 mt-3" color="success white--text">ادامه
      </v-btn>

    </template>

    <v-dialog class="rounded-lg" v-model="paymentDialog" scrollable max-width="600px">
      <v-card class="rounded-lg">
        <v-card-title class="rounded-lg">روش پرداخت</v-card-title>
        <v-card-text>
          <v-simple-table>
            <tbody>
            <tr>
              <th>موجودی کیف پول شما:</th>
              <td>
                <span>{{ user.wallet.balance | toMoney }}</span>
                ریال
              </td>
              <td>
                <v-checkbox
                    v-model="item.pay_from_wallet"
                    label="پرداخت از کیف پول"
                    :disabled="user.wallet.balance == 0"
                />
              </td>
            </tr>
            <tr>
              <th>مبلغ فاکتور</th>
              <td>
                <span>{{ sum | toMoney }}</span>
                ریال
              </td>
              <td></td>
            </tr>
            <tr>
              <th>تخفیف</th>
              <td>
                <span>{{ 0 | toMoney }}</span>
              </td>
              <td class="d-flex">
                <v-text-field placeholder="کد تخفیف" v-model="item.discount_code" class="rounded-lg mt-1"/>
                <v-btn depressed color="secondary" outlined class="rounded-lg mr-2 mt-2 pt-4 pb-4">اعمال</v-btn>
              </td>
            </tr>
            <tr>
              <th>مبلغ باقیمانده:</th>
              <td>
                <span>{{ getRemain() | toMoney }}</span>
                ریال
              </td>
              <td></td>
            </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="pay" depressed class="rounded-lg primary white--text w-100px">پرداخت</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </m-form>
</template>

<script>
import {MFormMixin} from "@/components/m-form";
import GetUserApi from "@/views/panel/user/getUserApi.js";
import SubscriptionMixin from "./mixin";

export default {
  name: "SubscriptionFactorForm",
  mixins: [MFormMixin, SubscriptionMixin, GetUserApi],
  props: {
    id: {},
  },
  data() {
    return {
      baseUrl: "subscriptions/factor",
      appendSlash: false,
      hasList: false,
      paymentDialog: false,
    };
  },
  computed: {
    title() {
      if (this.item.is_shopping_cart) return "سبد خرید";
      return "جزئیات فاکتور";
    },
    headers() {
      let headers = [
        {
          text: "نوع",
          value: "type",
          items: this.factorItemTypes,
          filterable: false,
          sortable: false
        },
        {
          text: "پلن",
          value: "plan",
          filterable: false,
          sortable: false
        },
        {
          text: "مبلغ",
          value: "amount",
          type: "numeric",
          filterable: false,
          sortable: false
        },
      ];
      if (!this.item.is_paid) {
        headers.push({
          text: "",
          value: "remove",
          sortable: false,
          filterable: false,
        });
      }
      return headers;
    },
    sum() {
      let sum = 0;
      if (this.rows.length) {
        this.rows.forEach((row) => {
          if (row.id) sum += Number(row.amount);
        });
      }
      return sum;
    },
  },
  mounted() {
    const route = this.$route;
    if (route.query.success == "true") {
      this.successNotify();
      this.$router.push({
        name: route.name,
        params: route.params,
      });
    }
  },
  methods: {
    getItem() {
      let url;
      if (this.id == "shoppingCard") url = "subscriptions/shoppingCard";
      else url = this.retrieveUrl;

      this.request({
        url: this.endpoint(url),
        method: "get",
        success: (data) => {
          this.setItem(data);
        },
      });
    },
    getRemain() {
      if (this.item.pay_from_wallet) {
        return Math.max(0, this.sum - this.user.wallet.balance);
      } else return this.sum;
    },
    setItem(item) {
      this.item = item;
      this.rows = this.copy(this.item.items);
      this.rows.push({
        amount: this.item.items.reduce((v, o) => (v += Number(o.amount)), 0),
        plan: "مجموع",
      });
      if (this.hasIdProp && this.id != item.id) {
        this.changeRouteTo(item.id);
      }
    },
    removeRow(item) {
      this.request({
        url: this.endpoint("subscriptions/shoppingCard"),
        method: "delete",
        data: {
          id: item.id,
        },
        success: (data) => {
          this.successNotify();
          this.rows = this.rows.filter((o) => o.id != item.id);
          this.rows[this.rows.length - 1].amount -= Number(item.amount);
        },
      });
    },
    pay() {
      if (this.getRemain() > 0) {
        this.request({
          url: this.endpoint("subscriptions/transactions"),
          method: "post",
          data: {
            amount: this.getRemain(),
            factor: this.id,
          },
          success: (data) => {
            window.location = data.redirect_url;
          },
        });
      } else {
        this.request({
          url: this.endpoint("subscriptions/shoppingCard/pay"),
          method: "post",
          success: (data) => {
            this.getUser();
            this.getItem();
            this.successResponse(data);
            this.paymentDialog = false;
          },
        });
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
